<mat-card>
    <mat-card-title [ngClass]="to.disabled ? 'text-disabled' : 'text-enabled'">{{to.sequence}}. {{ to.label }}
        <span [ngClass]="{ commentRequire: questionClickData.has(this.to.id) }">
            <mat-icon *ngIf="isQuestionCommentEnabled" 
                [ngClass]="(isCommentFieldFilled === true) ? 'question-comment-green' : isQuestionCommentRequired === true ? 'question-comment-red' : 'question-comment'" 
                (click)="openCommentConfirmation(this.field)">edit</mat-icon>
        </span>
    </mat-card-title>
    <mat-card-content>
        <div fxFlex>
            <ng-container #fieldComponent></ng-container>
        </div>
    </mat-card-content>
</mat-card>
<!-- COMMENT MODAL STARTS HERE-->
<ng-template #commentDialog>
    <div class="modal-header">
        <h4 class="modal-title pull-left no-margin">Comment</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefConf.hide();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" >
       
            <div fxLayout="row nowrap">
                <form [formGroup]="commentForm"  class="text-area-class">
                    <formly-form  [model]="commentModel" [fields]="commentFields" [options]="commentOptions"
                     [form]="commentForm"></formly-form>
                  </form>
          </div> 
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default reject-button" (click)="modalRefConf.hide();">Close</button>
        <button type="button" class="btn btn-primary" (click)="onClick()">save</button>
    </div>
</ng-template>
<!-- COMMENT MODAL STARTS HERE-->